// extracted by mini-css-extract-plugin
module.exports = {"foodChainInformation":"foodChainInformation_foodChainInformation__1Rrxk","input":"foodChainInformation_input__3QrrC"};